import { render, staticRenderFns } from "./exhibitionIntro.vue?vue&type=template&id=40f1e648&scoped=true&"
var script = {}
import style0 from "./exhibitionIntro.vue?vue&type=style&index=0&id=40f1e648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1e648",
  null
  
)

export default component.exports